module.exports = __webpack_public_path__ + "img/delivery-agent.5bec2aa3.svg";